import React, { Fragment } from "react";
import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

import Navbar from "@common/Navbar";
import AnimateWrapper from "@common/animations/AnimateWrapper";
import VariantCard from "./components/VariantCard";

const PREFIX = "SelectVariantContainer";

const classes = {
  innerContainer: `${PREFIX}-innerContainer`,
  title: `${PREFIX}-title`,
};

const StyledAnimateWrapper = styled(AnimateWrapper)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  margin: "auto 0",
  padding: theme.spacing(5, 0),
  alignItems: "center",

  [`& .${classes.innerContainer}`]: {
    width: "60%",
    maxWidth: 700,
    [theme.breakpoints.down("md")]: {
      width: "80%",
    },
  },

  [`& .${classes.title}`]: {
    fontWeight: 500,
    color: theme.palette.accentText.primary,
    marginBottom: theme.spacing(3),
  },
}));

const SelectVariantContainer = ({ product, onClickFn, setPageNum, setSelectedVariant }) => {
  const handleSelection = (variant) => {
    setSelectedVariant(variant);
    onClickFn();
  };

  return (
    <Fragment>
      <Navbar onBack={() => setPageNum("ProductDescription")} progressBarOffSet />
      <StyledAnimateWrapper motionKey="SelectVariant">
        <div className={classes.innerContainer}>
          <Typography variant="h5" className={classes.title}>
            Which variant are you looking at?
          </Typography>
          {product &&
            product.variants.length > 0 &&
            product.variants.map((variant, index) => (
              <VariantCard
                key={`variant-${index}`}
                variant={variant}
                index={index}
                handleSelection={handleSelection}
              />
            ))}
        </div>
      </StyledAnimateWrapper>
    </Fragment>
  );
};

export default SelectVariantContainer;
